import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, Slide, withStyles } from 'material-ui';
import DialogStyles from './CalendarDialogStyles';
import Tabs from './CalendarTabs';
import CalendarHeader from '../../../../components/flights/calendarMobile/CalendarHeader';

function Transition (props) {
  return <Slide direction='left' {...props} />;
}

const CalendarDialog = ({
  selectedRoute,
  selectedTrip,
  selectDate,
  flights,
  open,
  handleClose,
  handleTabChange,
  selectedTab,
  departureFlight,
  arrivalFlight,
  classes,
}) => (
  <div className='calendar-screen'>
    <Dialog fullScreen open={open} onClose={handleClose} transition={Transition} classes={classes}>
      <CalendarHeader selectedTrip={selectedTrip} handleClose={handleClose} />
      <Tabs
        selectedRoute={selectedRoute}
        selectedTrip={selectedTrip}
        selectedTab={selectedTab}
        handleTabChange={handleTabChange}
        selectDate={selectDate}
        flights={flights}
        departureFlight={departureFlight}
        arrivalFlight={arrivalFlight}
      />
      <div className='calendar-dialog-footer'>
        <Button
          variant='raised'
          fullWidth
          color='primary'
          onClick={handleClose}
          className={classes.button}
        >
          Done
        </Button>
      </div>
    </Dialog>
  </div>
);

CalendarDialog.propTypes = {
  selectedRoute: PropTypes.object,
  selectedTrip: PropTypes.object,
  departureFlight: PropTypes.object,
  arrivalFlight: PropTypes.object,
  flights: PropTypes.arrayOf(PropTypes.object),
  selectDate: PropTypes.func,
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  selectedTab: PropTypes.number,
  handleTabChange: PropTypes.func,
  classes: PropTypes.object,
};

export default withStyles(DialogStyles)(CalendarDialog);



// WEBPACK FOOTER //
// ./src/containers/flights/mobile/calendar/CalendarDialog.js